let user = [
    {
        path: '/user/account',
        name: 'list',
        component: () => import('@/views/user/account/list.vue'),
        meta: {keepAlive: true, parentPath: 'user'},
    },
    {
        path: '/user/account/edit',
        name: 'edit',
        component: () => import('@/views/user/account/edit.vue'),
        meta: {keepAlive: true, parentPath: 'user'},
    },
    {
        path: '/user/level',
        name: 'level',
        component: () => import('@/views/user/level.vue'),
        meta: {keepAlive: true, parentPath: 'user'},
    }
    ,
    {
        path: '/user/distribution',
        name: 'distribution',
        component: () => import('@/views/user/distribution.vue'),
        meta: {keepAlive: true, parentPath: 'user'},
    }
    ,
    {
        path: '/user/userconfig',
        name: 'userconfig',
        component: () => import('@/views/user/userconfig.vue'),
        meta: {keepAlive: true, parentPath: 'user'},
    },
    {
        path: '/user/membercard',
        name: 'membercard',
        component: () => import('@/views/user/membercard.vue'),
        meta: {keepAlive: true, parentPath: 'user'},
    }
    
]
export default user


// WEBPACK FOOTER //
// ./src/router/user.js